import {Segmented} from "antd";
import {useState} from "react";
import {SingleLayerSettingsStory} from "../singleLayer/SingleLayerSettingsStory";
import {useParams} from "react-router-dom";

export function SplitViewSettingsStory() {
    let {id, idSplit} = useParams();
    const [isRightView, setIsRightView] = useState(true)

    function onChangeView(value) {
        setIsRightView(value === 'Right')
    }

    return (
        <div style={{
            height: 'calc(100% - 0px)',
        }}>
            <Segmented
                style={{
                    position: 'absolute',
                    top: 60,
                    right: 0,
                    left: 0,
                }}
                defaultValue="Right"
                options={["Left", "Right"]}
                onChange={onChangeView}
                block/>
            <div style={{height: 20}}></div>
            {!isRightView && <SingleLayerSettingsStory id={id}/>}
            {isRightView && <SingleLayerSettingsStory id={idSplit}/>}
        </div>
    )
}